import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-material-ui',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Material-UI icon</title><path d="M0 2.475v10.39l3 1.733V7.67l6 3.465 6-3.465v3.465l-6 3.463v3.464l6 3.463 9-5.195V9.402l-3 1.733v3.463l-6 3.464-3-1.732 6-3.465V2.475L9 7.67 0 2.475zm24 0l-3 1.73V7.67l3-1.732V2.474Z"/></svg>`,
    styles: []
})
export class SimpleIconsMaterialUiComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#0081CB';
    @Input() className: string = 'simple-icons-material-ui'
    constructor() {}
    ngOnInit(): void {}
}
